import Emergency from './Emergency';

export default {
  'emergency-request': {
    screen: Emergency,
  },
};